
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airdrop",
      function () {
        return require("private-next-pages/airdrop.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airdrop"])
      });
    }
  